import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPartMngList({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			partNo: searchParams.partNo,
			partNm: searchParams.partNm,
			useYn: searchParams.useYn,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/comm/qmsbase/partMng/v1/parts${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updatePart(param) {
		try {
			const response = await client.post(`${BASE_URL}/comm/qmsbase/partMng/v1/status/2`, param);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
